import { numberToPrettyString } from '@cian/utils';

import { isCommercialLand } from './isCommercialLand';
import { IOffer } from '../../../types/offer';

interface IPricePerUnitArea {
  value: number;
  unit: string;
}

function getPricePerUnitArea(offer: IOffer): IPricePerUnitArea | undefined {
  if (offer.pricePerUnitAreaRur && offer.pricePerUnitAreaRur > 0) {
    // Для земли сервер считает цену за сот./га, а не за м²
    const unit = isCommercialLand(offer) ? (offer.land?.areaUnitType === 'hectare' ? 'га' : 'сот.') : 'м²';

    return { value: offer.pricePerUnitAreaRur, unit };
  }

  const priceRur = offer.bargainTerms?.priceRur;
  const priceType = offer.bargainTerms?.priceType;

  if (priceRur) {
    if (priceType === 'squareMeter') {
      return { value: priceRur, unit: 'м²' };
    }

    if (priceType === 'sotka' || priceType === 'hectare') {
      return { value: priceRur, unit: priceType === 'hectare' ? 'га' : 'сот.' };
    }
  }

  const totalArea = Number(offer.totalArea);
  if (!Number.isFinite(totalArea) || totalArea <= 0) {
    return undefined;
  }

  const totalPrice = priceRur || offer.minPriceTotalRur;
  if (!totalPrice || totalPrice <= 0) {
    return undefined;
  }

  return { value: Math.round(totalPrice / totalArea), unit: 'м²' };
}

export function getCommercialSalePricePerMeter(offer: IOffer): string | undefined {
  const pricePerUnitArea = getPricePerUnitArea(offer);
  if (!pricePerUnitArea) {
    return undefined;
  }

  return `${numberToPrettyString(pricePerUnitArea.value)} ₽/${pricePerUnitArea.unit}`;
}
